import axios from 'axios';
import jsonpAdapter from 'axios-jsonp';

const cache = {};

export function getCidInfo(cid) {
  return axios({
    url: '//union.video.qq.com/fcgi-bin/data?otype=json&union_jsonp=1&tid=1499&appid=20002193&appkey=f411406d3a88d9b9',
    adapter: jsonpAdapter,
    params: { idlist: cid },
  });
}

export function getVidInfo(vid) {
  return axios({
    url: '//union.video.qq.com/fcgi-bin/data?otype=json&union_jsonp=1&tid=1508&appid=20002193&appkey=f411406d3a88d9b9',
    adapter: jsonpAdapter,
    params: { idlist: vid },
  });
}

export async function getPlayright({ cid, vid }) {
  let fields;

  if (vid) {
    if (!cache[vid]) {
      cache[vid] = getVidInfo(vid);
    }
    const res = await cache[vid];
    delete cache[vid];
    fields = res?.data?.results[0].fields || {};
  }

  if (!vid && cid) {
    if (!cache[cid]) {
      cache[cid] = getCidInfo(cid);
    }
    const res = await cache[cid];
    delete cache[cid];

    fields = res?.data?.results[0].fields || {};
    if (fields) {
      if (!vid) {
        // eslint-disable-next-line
        vid = fields.video_ids[0];
      }
    }
  }

  return { cid, vid, fields };
}

const cmsidCache = {};

export async function getNewsCMSID({ cid, vid }) {
  if (vid) {
    if (!cmsidCache[vid]) {
      cmsidCache[vid] = axios({
        url: '//vip.video.qq.com/v1/long/video/get',
        method: 'POST',
        data: { vid: [vid], feature: [1] },
      });
    }
    const res = await cmsidCache[vid];
    delete cmsidCache[vid];

    if (res?.data?.code === 0 && res?.data?.data[vid]?.basic?.ID) {
      return {
        news_id: res.data.data[vid]?.basic.ID,
        cur_vid: res.data.data[vid]?.basic.ID,
      };
    }
  }

  if (cid) {
    if (!cmsidCache[cid]) {
      cmsidCache[cid] = axios({
        url: '//vip.video.qq.com/v1/long/album/get',
        method: 'POST',
        data: { cid: [cid], feature: [1] },
      });
    }
    const res = await cmsidCache[cid];
    delete cmsidCache[cid];

    if (res?.data?.code === 0 && res?.data?.data[cid]?.basic?.ID) {
      return {
        news_id: res.data.data[cid]?.basic.ID,
      };
    }
  }

  return false;
}
